export const data = [
  {
    id: 0,
    title: "Websites",
    description: "A collection of websites I’ve built as a frontend developer.",
    works: [
      {
        id: 0.0,
        title: "Art Commissions | 2020",
        image:
          "https://cdn.discordapp.com/attachments/798636076662390805/849380626485870612/unknown.png",
        link: "https://commissions.amaryllis.cc",
        github_link: "https://github.com/AmaryllisNO/semester-project-2",
        popup: {
          popup_description: `This website was part of my last semester project of 2020 as part of my studies at Noroff. It stands as an example of an e-commerce website where a user can commission an artist through their platform, complete with it's own cart system. All of the products are maintained via a headless CMS (Strapi). The admin can do CRUD operations on any of the products.`,
          tech_stack: [
            "HTML",
            "SASS/SCSS",
            "JavaScript",
            "Strapi API",
            "Heroku",
          ],
        },
      },
      {
        id: 0.1,
        title: "Grafix | 2021",
        image:
          "https://cdn.discordapp.com/attachments/798636076662390805/849381320466759690/unknown.png",
        link: "https://grafix-website.vercel.app/",
      },
      {
        id: 0.2,
        title: "Holidaze | 2021",
        image:
          "https://cdn.discordapp.com/attachments/798636076662390805/849629513574252594/unknown.png",
        link: "https://nervous-wiles-cd1d71.netlify.app/",
      },
    ],
  },
  {
    id: 1,
    title: "Graphics",
    description:
      "A collection of graphic designs I’ve made for myself and others.",
    works: [
      {
        id: 1.0,
        title: "Character Logo",
        image: "https://amaryllis.cc/assets/svg/work/amary-logo-black2.svg",
      },
      {
        id: 1.1,
        title: "Amaryllis Logo",
        image: "https://amaryllis.cc/assets/svg/work/amaryllis-text-logo.svg",
      },
      {
        id: 1.2,
        title: "Amaryllis Icon",
        image: "https://amaryllis.cc/assets/svg/work/amathirdgen.svg",
      },
      {
        id: 1.3,
        title: "Techy Abstract",
        image: "https://amaryllis.cc/assets/svg/work/techy.svg",
      },
      {
        id: 1.4,
        title: "Cycling Company Logo",
        image: "https://amaryllis.cc/assets/svg/work/recyclelogo.svg",
      },
    ],
  },
  {
    id: 2,
    title: "Art",
    description: "A collection of artworks I have made over the years.",
    works: [
      {
        id: 0,
        title: "Skybreak - Moonglow Cover Art",
        thumbnail:
          "https://amaryllis.cc/assets/img/art/portfolio/skybreak_moonglow.png",
        image:
          "https://amaryllis.cc/assets/img/art/portfolio/skybreak_moonglow.png",
      },
      {
        id: 1,
        title: "Boxplot - Here & Now",
        thumbnail:
          "https://amaryllis.cc/assets/img/art/portfolio/Boxplot%20Commission%20FINAL.jpg",
        image:
          "https://amaryllis.cc/assets/img/art/portfolio/Boxplot%20Commission%20FINAL.jpg",
      },
      {
        id: 2,
        title: "glasse - The Keeper of Death",
        thumbnail:
          "https://amaryllis.cc/assets/img/art/portfolio/Glasse%202.jpg",
        image: "https://amaryllis.cc/assets/img/art/portfolio/Glasse%202.jpg",
      },
      {
        id: 3,
        title: "Synthion - Windrunner",
        thumbnail:
          "https://amaryllis.cc/assets/img/art/thumbnails/djpoyoshi-commission.jpg",
        image:
          "https://amaryllis.cc/assets/img/art/portfolio/DJPoyoshi%20Commission.png",
      },
      {
        id: 4,
        title: "Null∅ - VIE",
        thumbnail:
          "https://amaryllis.cc/assets/img/art/portfolio/vieeeeeee.png",
        image: "https://amaryllis.cc/assets/img/art/portfolio/vieeeeeee.png",
      },
      {
        id: 5,
        title: "Looking Up - Personal Piece",
        thumbnail: "https://amaryllis.cc/assets/img/art/portfolio/academy.png",
        image: "https://amaryllis.cc/assets/img/art/portfolio/academy.png",
      },
      {
        id: 6,
        title: "Blaidd - Elden Ring Fanart",
        thumbnail:
          "https://amaryllis.cc/assets/img/art/portfolio/blaidd_the_half_wolf_by_amaryllisno_df260uv-fullview.jpg",
        image:
          "https://amaryllis.cc/assets/img/art/portfolio/blaidd_the_half_wolf_by_amaryllisno_df260uv-fullview.jpg",
      },
      {
        id: 7,
        title: "Landscape Sketch",
        thumbnail:
          "https://amaryllis.cc/assets/img/art/portfolio/drawring_by_amaryllisno_dfqdayv-fullview.png",
        image:
          "https://amaryllis.cc/assets/img/art/portfolio/drawring_by_amaryllisno_dfqdayv-fullview.png",
      },
      {
        id: 8,
        title: "Amaryllis - Light Pillars II",
        thumbnail:
          "https://amaryllis.cc/assets/img/art/portfolio/light_pillars_ii_by_amaryllisno_df9okuh-pre.jpg",
        image:
          "https://amaryllis.cc/assets/img/art/portfolio/light_pillars_ii_by_amaryllisno_df9okuh-pre.jpg",
      },
    ],
  },
  {
    id: 3,
    title: "Music",
    description: "A collection of music I have produced.",
  },
];
